module.exports = __webpack_public_path__ + "static/media/yoga-tennis-woman-emoji.6499ee07.svg";